import apiClient from './client';

/**
 * Fetch live dashboard analytics stats from the backend.
 * Returns { campaigns: {...}, individual: {...} }
 */
export const getAnalyticsStats = async (params = {}) => {
  const response = await apiClient.get('/dashboard/stats/', { params });
  return response.data;
};

/**
 * Fetch WhatsApp Manager-style "Message pricing" insights: exact message-status
 * counts plus live per-category pricing volumes/charges from Meta.
 */
export const getMessagePricingStats = async (params = {}) => {
  const response = await apiClient.get('/dashboard/message-pricing/', { params });
  return response.data;
};

/**
 * Fetch the actual contacts/messages behind one Message Pricing row (drill-down).
 * @param {object} params - { range, start_date, end_date, phone_number_id, metric, category, free_type }
 */
export const getMessagePricingDetail = async (params = {}) => {
  const response = await apiClient.get('/dashboard/message-pricing-detail/', { params });
  return response.data;
};

/**
 * Fetch full detail for one campaign including all messages and their statuses.
 * @param {number|string} campaignId
 */
export const getCampaignDetail = async (campaignId) => {
  const [campaignRes, messagesRes] = await Promise.all([
    apiClient.get(`/campaigns/${campaignId}/`),
    apiClient.get(`/campaigns/${campaignId}/messages/`),
  ]);
  const campaign = campaignRes.data;
  const messages = messagesRes.data?.results ?? messagesRes.data ?? [];
  return { campaign, messages };
};

/**
 * Fetch messages for a specific contact (individual conversation analytics).
 * @param {number|string} contactId
 */
export const getAnalyticsContactMessages = async (contactId) => {
  const response = await apiClient.get('/inbox/messages/', {
    params: { contact_id: contactId, page_size: 500 },
  });
  return response.data?.results ?? response.data ?? [];
};

/**
 * Fetch all campaigns (for table listing).
 */
export const getAllCampaigns = async () => {
  const response = await apiClient.get('/campaigns/');
  return response.data?.results ?? response.data ?? [];
};

/**
 * Fetch all contacts that have individual messages (for contact analytics).
 */
export const getContactsWithMessages = async () => {
  const response = await apiClient.get('/contacts/', {
    params: { page_size: 100 },
  });
  return response.data?.results ?? response.data ?? [];
};
